// React
import React from 'react'
import PropTypes from 'prop-types'

// Components
import BProductButton from './styles'
import Skeleton from 'ui/blocks/Skeleton'

// Libraries
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSpinnerThird as farSpinnerThird,
  faCheck as farCheck,
  faTimes as farTimes
} from '@fortawesome/pro-regular-svg-icons'

const Button = ({ loading, disabled, status, behavior, onClick, label }) => {
  if (!behavior) {
    return (
      <BProductButton.SkeletonContainer>
        <Skeleton />
      </BProductButton.SkeletonContainer>
    )
  }

  return (
    <BProductButton.Button
      onClick={onClick}
      disabled={disabled}
      loading={loading || undefined}
      status={status}
      className="bq-button"
    >
      <BProductButton.ButtonLabel>{label}</BProductButton.ButtonLabel>
      {loading && (
        <BProductButton.ButtonOverlay>
          <FontAwesomeIcon className="loading" icon={farSpinnerThird} size="sm" />
        </BProductButton.ButtonOverlay>
      )}
      {status === 'success' && (
        <BProductButton.ButtonOverlay>
          <FontAwesomeIcon icon={farCheck} size="sm" />
        </BProductButton.ButtonOverlay>
      )}
      {status === 'error' && (
        <BProductButton.ButtonOverlay>
          <FontAwesomeIcon icon={farTimes} size="sm" />
        </BProductButton.ButtonOverlay>
      )}
    </BProductButton.Button>
  )
}

Button.propTypes = {
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  status: PropTypes.oneOf(['success', 'error']),
  behavior: PropTypes.oneOf(['show_cart', 'checkout']),
  label: PropTypes.any
}

export default Button
